import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["src", "height"]

interface NutriscoreDisplayProps {
  rating: string|null,
  height? : number,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NutriscoreDisplay',
  props: {
    rating: { default: null },
    height: { default: 30 }
  },
  setup(__props: any) {


const props = __props;

const src = (props.rating) ? `/assets/img/nutriscore/nutri-${props.rating}.png` : '';

return (_ctx: any,_cache: any) => {
  return (_unref(src))
    ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        alt: "nutriscore",
        src: _unref(src),
        height: _ctx.height
      }, null, 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})